<template>
  <div class="l-select-box">
    <div v-if="list.length == 0" class="l-select-box-placeholder">
      {{ placeholder }}
    </div>
    <div v-else class="l-select-box-list">
      <div v-for="(item, index) in list" :key="index" class="l-select-box-item">
        <slot name="btns"><div class="l-select-box-item-content" >{{$t(item.label)}}</div></slot>
      </div>
      <div  v-if="multiple" class="l-select-box-add" >{{$t(placeholder)}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "l-select-box",
  props: {
    value: {},
    placeholder: {
      type: String,
      default: "点击添加",
    },
    labelKey: {
      type: String,
      default: "label",
    },
    valueKey: {
      type: String,
      default: "value",
    },
    size: {
      type: String,
      //default: "mini",
    },
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    disabled: Boolean,
    filterable: {
      type: Boolean,
      default: true,
    },
    filterMethod: Function,
    multiple: Boolean,
    collapseTags: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      list: [
        {
          value: "xxxx",
          label: "测试数据",
        }
      ],
    };
  },
  mounted() {},
  computed: {
    value2: {
      get() {
        if (this.multiple) {
          if (!this.$validatenull(this.value)) {
            return (this.value + "").split(",");
          } else {
            return [];
          }
        } else {
          return this.value;
        }
      },
      set(val) {
        if (this.multiple) {
          this.$emit("input", String(val));
        } else {
          this.$emit("input", val);
        }
      },
    },
  },
  methods: {
    handleChange(val) {
      if (this.multiple) {
        if (val.length == 0) {
          this.$emit("change", undefined);
          return;
        }

        const objs = [];
        val.forEach((item) => {
          const objone = this.options.find((t) => t[this.valueKey] == item);
          objs.push(objone);
        });
        this.$emit("change", objs);
      } else {
        if (val == "") {
          this.$emit("change", undefined);
          return;
        }
        const obj = this.options.find((t) => t[this.valueKey] == val);
        this.$emit("change", obj);
      }
    },
    handleClear() {
      this.$emit("clear");
    },
    handleVisibleChange(e) {
      this.$emit("veisibleChange", e);
    },
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
